export const Cross = () => {
	return (
		<svg x="0px" y="0px" className={"svg-filter"} viewBox="0 0 16 16">
			<title>cross mark</title>
			<g id={"cross_mark_5_"}>
				<g>
					<path
						d="M9.41,8l3.29-3.29C12.89,4.53,13,4.28,13,4c0-0.55-0.45-1-1-1
                                    c-0.28,0-0.53,0.11-0.71,0.29L8,6.59L4.71,3.29C4.53,3.11,4.28,3,4,3C3.45,3,3,3.45,3,4c0,0.28,0.11,0.53,0.29,0.71L6.59,8
                                    l-3.29,3.29C3.11,11.47,3,11.72,3,12c0,0.55,0.45,1,1,1c0.28,0,0.53-0.11,0.71-0.29L8,9.41l3.29,3.29C11.47,12.89,11.72,13,12,13
                                    c0.55,0,1-0.45,1-1c0-0.28-0.11-0.53-0.29-0.71L9.41,8z"
					/>
				</g>
			</g>
		</svg>
	);
};

export const Trash = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className={"svg-filter"}
			height="18"
			viewBox="0 96 960 960"
			width="18"
		>
			<title>trash can</title>
			<path
				d="M261 936q-24.75 0-42.375-17.625T201 
              876V306h-41v-60h188v-30h264v30h188v60h-41v570q0 24-18 42t-42 
              18H261Zm438-630H261v570h438V306ZM367 
              790h60V391h-60v399Zm166 0h60V391h-60v399ZM261 306v570-570Z"
			/>
		</svg>
	);
};
